import { render, staticRenderFns } from "./call-actions.vue?vue&type=template&id=53337bb3&scoped=true"
import script from "./call-actions.vue?vue&type=script&lang=js"
export * from "./call-actions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53337bb3",
  null
  
)

export default component.exports